import { fromJS } from 'immutable';
import { compose } from 'ramda';
var parseJSON = compose(fromJS, JSON.parse);
export function parseActivity(activity) {
  return activity.update('payload', parseJSON) // an activity should always have a payload
  .update('createdAt', function (date) {
    return date && new Date(date);
  }).update('modifiedAt', function (date) {
    return date && new Date(date);
  });
}
export function parseActivities(activities) {
  return activities.map(parseActivity);
}